import { window } from "global";
import { useEffect } from "react";
import { usePageTitleAndDesc } from "@ugg/shared/utils/seo-helpers";
import { Link } from "react-router-dom";
import { SvgArrowPointRight } from "@ugitgud/legos/ui/icon/SVG/ArrowPointRight";
import { getCareersPostUrl } from "@ugg/shared/routes/app-routes";
import { JOB_POSTINGS } from "./jobPostings";

const CareersHome = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  const departments = [...new Set(JOB_POSTINGS.map((job) => job.department))];

  return (
    <div className="text-content-container px-6">
      {getPageTitleAndDesc("careers")}
      <div className="text-content">
        <h1 className="mb-8">Careers at U.GG</h1>
        <p className="!text-lavender-50 mb-4">
          U.GG is an incredibly fast growing startup founded to address information problems that millions of video game players
          around the world face on a daily basis. We are backed by a wide range of investors who truly believe in the space,
          including the Philadelphia 76ers innovation fund.
        </p>
        <p className="!text-lavender-50 mb-10">
          Want to have immediate impact? Want to have ownership? Love the gaming space? If so, U.GG would be a perfect fit.
        </p>
        {JOB_POSTINGS.length === 0 ? (
          <span className="text-gray-400 text-[16px]">No open positions at this time. Check back soon!</span>
        ) : (
          departments.map((dept) => (
            <div key={dept} className="mb-10">
              <h2 className="mb-4">{dept}</h2>
              <div className="flex flex-col gap-2">
                {JOB_POSTINGS.filter((job) => job.department === dept).map((job) => (
                  <Link
                    key={job.slug}
                    to={getCareersPostUrl(job.slug)}
                    className="flex items-center justify-between rounded-lg bg-purple-400 px-5 py-4 hover:bg-purple-100 !no-underline"
                  >
                    <div className="flex flex-col gap-1">
                      <span className="text-[14px] text-white font-semibold">{job.title}</span>
                      <span className="text-[12px] text-gray-400">
                        {job.location} &middot; {job.type}
                      </span>
                    </div>
                    <div className="text-white h-[24px] w-[24px]">
                      <SvgArrowPointRight />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CareersHome;
